export const FETCH_PROJECT_ACCESS_VALUE = 'FETCH_PROJECT_ACCESS_VALUE';

export const fetchProjectAccessValue = () => ({
	type: FETCH_PROJECT_ACCESS_VALUE,
	payload: {},
});

export type FetchProjectAccessValue = ReturnType<typeof fetchProjectAccessValue>;
